
import { Vue, Prop, Component, Emit } from 'vue-property-decorator'
import MultiSelectField from '../../commons/fields/MultiSelectField.vue'
import HdsCheckboxCross from '../../commons/fields/HdsCheckboxCross.vue'
import FormContainer from '../../commons/forms/FormContainer.vue'
import axios from 'axios'
import { IStatutoryPurpose } from '@/types/processingSteps'

@Component({
  components: {
    MultiSelectField,
    HdsCheckboxCross,
    FormContainer
  }
})
export default class RemainingFundsUsage extends Vue {
  @Prop({ required: true }) deviation!: number
  @Prop({ required: true }) isReportDraft!: boolean
  @Prop({ required: true }) excessFundsHandling!: number
  @Prop({ required: true }) excessFundsPurposes!: IStatutoryPurpose[]

  statutoryPurposes: IStatutoryPurpose[] = []

  isCollapseOpen = false

  get selectedPurposes (): number[] {
    if (!Array.isArray(this.excessFundsPurposes)) {
      return []
    }
    return this.excessFundsPurposes?.map(p => {
      if (typeof p === 'number') {
        return p
      }
      return p.id
    }) || []
  }

  get charityPurposeHintHtml(): string {
    return this.$gettext('If not all donations have been used as originally planned, it must be confirmed that all remaining funds have been used in accordance with a German charitable purpose (<a href="https://www.gesetze-im-internet.de/ao_1977/BJNR006130976.html" target="_blank">AO - German Fiscal Code</a>)')
  }

  get paybackHintHtml (): string {
    return this.$gettext('If you have not been able to use all remaining funds in accordance with a German charitable purpose (<a href="https://www.gesetze-im-internet.de/ao_1977/BJNR006130976.html" target="_blank">AO - German Fiscal Code</a>), these must be repaid to Haus des Stiftens.')
  }

  setSelectedPurposes(ids: number[]) {
    this.$emit('update:excessFundsPurposes', ids)
  }

  get isFormDisabled (): boolean {
    return this.hasNoDeviationsOrSpentMoreThanReceived || !this.isReportDraft
  }

  get hasNoDeviationsOrSpentMoreThanReceived (): boolean {
    return this.deviation >= 0
  }

  async mounted (): Promise<void> {
    await this.fetchStatutoryPurposes()
  }

  async fetchStatutoryPurposes (): Promise<void> {
    const url = "/api/v4/processing-steps/statutory-purpose-options/"
    await axios.get(url).then(response => {
      this.statutoryPurposes = response.data.map((purpose: IStatutoryPurpose) => ({
        value: purpose.id,
        text: purpose.title
      }))
    })
  }

  @Emit('update:excessFundsHandling')
  selectUsage(choice: number) {
    if (this.isFormDisabled) {
      return
    }
    if (this.excessFundsHandling === choice) {
      // checkbox is being unchecked
      if (choice === 1) {
        this.$emit('update:excessFundsPurposes', [])
      }
      return 0
    }
    return choice
  }
}
